import { api } from './api';
import type {
  Task,
  CreateTaskRequest,
  TaskDescriptionSuggestion,
  GenerateTaskDescriptionRequest,
  TaskStatus,
  TaskComment
} from '@/types/task.ts';

export const taskApi = {
  getAllTasks: async (): Promise<Task[]> => {
    const response = await api.get<Task[]>('/tasks');
    return response.data;
  },

  getTask: async (id: number): Promise<Task> => {
    const response = await api.get<Task>(`/tasks/${id}`);
    return response.data;
  },

  getTasksByStatus: async (status: TaskStatus): Promise<Task[]> => {
    const response = await api.get<Task[]>(`/tasks/status/${status}`);
    return response.data;
  },

  getTasksByAssignee: async (userId: string): Promise<Task[]> => {
    const response = await api.get<Task[]>(`/tasks/assignee/${userId}`);
    return response.data;
  },

  getTasksByClient: async (clientId: number): Promise<Task[]> => {
    const response = await api.get<Task[]>(`/tasks/client/${clientId}`);
    return response.data;
  },

  getTasksByFeedItem: async (feedItemId: number): Promise<Task[]> => {
    const response = await api.get<Task[]>(`/tasks/feeditem/${feedItemId}`);
    return response.data;
  },

  createTask: async (request: CreateTaskRequest): Promise<Task> => {
    const response = await api.post<Task>('/tasks', request);
    return response.data;
  },

  generateTaskDescription: async (request: GenerateTaskDescriptionRequest): Promise<TaskDescriptionSuggestion> => {
    const response = await api.post<TaskDescriptionSuggestion>('/tasks/generate-description', request);
    return response.data;
  },

  updateTask: async (id: number, updates: Partial<Task>): Promise<Task> => {
    const response = await api.put<Task>(`/tasks/${id}`, updates);
    return response.data;
  },

  updateTaskStatus: async (id: number, status: TaskStatus): Promise<Task> => {
    const response = await api.post<Task>(`/tasks/${id}/status`, { status });
    return response.data;
  },

  addComment: async (taskId: number, content: string): Promise<TaskComment> => {
    const response = await api.post<TaskComment>(`/tasks/${taskId}/comments`, { content });
    return response.data;
  },

  deleteTask: async (id: number): Promise<void> => {
    await api.delete(`/tasks/${id}`);
  },
};
